import { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from "../../../utils/CommonHelper";
import { useAuth } from "../../auth/components/AuthInit";
import { fetchIPAddress } from "../../auth/redux/LoginCRUD";
import * as actions from "../redux/MasterLayoutAction";
import { Modal } from "./Modal";

export const ContactUsModal = ({ setSwalProps }) => {
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const intl = useIntl();
  const { auth } = useAuth();

  const masterLayoutState = useSelector(
    ({ masterLayout }) => masterLayout,
    shallowEqual
  );

  useEffect(() => {
    fetchIPAddress().then((res) => {
      dispatch(
        actions.fetchContactLists({
          ipaddress: auth?.currencycode ? "" : res.ip,
          currencycode: auth?.currencycode ?? "",
        })
      );
    });
  }, [auth]);

  return (
    <Modal
      modalId="liveChatModal"
      title={intl.formatMessage({ id: "liveChat" })}
      dismissBtnRef={dismissBtnRef}
    >
      <div className="p-4 d-flex flex-column gap-4">
        {masterLayoutState.contactList?.contactLists.map((contact, index) => (
          <div className="d-flex align-items-center" key={index}>
            <div className="pe-3 pb-2">
              <img src={contact.iconurl} style={{ width: "40px" }} />
            </div>
            <div>
              <div>
                <a href={contact.directurl} target="_blank">
                  {contact.directurl}
                </a>
              </div>
              <div>
                {contact.telno}{" "}
                <i
                  className="ms-2 fa fa-copy cursor-pointer"
                  onClick={() =>
                    CopyToClipboard(contact.telno, setSwalProps, intl)
                  }
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};
